
//  I M P O R T S

// This is required to prevent an error which breaks *all* JS on pages without Sprig
import htmx from "htmx.org";


//  V A R I A B L E S

// Responsive functions

var actual_width;
var prev_width;
var curr_media;
var prev_media;
var check_media;

// Make sure these correspond with CSS

var xs = 480;
var sm = 576;
var md = 768;
var lg = 992;
var xl = 1024;
var xxl = 1200;

// Scroll tracking

var page_pos;
var nav_height;
var mobile_nav;
var mobile_nav_content;


//  F U N C T I O N S

function get_height(target) {
    // Get the height of an element without using height: auto on it and breaking CSS transitions
    if(!target) return;
    var clone = target.cloneNode(true);
    target.parentNode.appendChild(clone);
    clone.style.height = 'auto';
    var height = clone.clientHeight;
    clone.remove();
    return height;
}

var suggestions_div;
var min_query_length = false;
var suggestions_request;
var suggestions_request_active = false;
var suggestions_url;
var suggestions_loaded = false;
var suggestions_status;
var suggestions_status_h;
var suggestions_query;
var suggestions_list;

function load_suggestions() {
    suggestions_div.style.height = suggestions_status_h + 'px';
}

function hide_suggestions() {
    if(typeof suggestions_div === 'undefined') return;
    suggestions_div.style.height = 0;
    suggestions_status.style.opacity = 1;
}

function refresh_suggestions() {
    if(typeof suggestions_status === 'undefined') return;
    suggestions_status_h = get_height(suggestions_status);
    if (min_query_length) {
        load_suggestions();
    } else {
        hide_suggestions();
    }
}

function suggestions_status_fade_in() {
    suggestions_div.removeEventListener('transitionend', suggestions_status_fade_in);
    suggestions_div.style.pointerEvents = 'all';
    suggestions_status.style.opacity = 1;
}

function suggestions_status_expand() {
    suggestions_div.style.opacity = 1;
    suggestions_status.style.display = '';
    suggestions_div.style.height = get_height(suggestions_status) + 'px';
    suggestions_div.addEventListener('transitionend', suggestions_status_fade_in, false);
}

function suggestions_list_fade_in() {
    suggestions_div.removeEventListener('transitionend', suggestions_list_fade_in);
    suggestions_list.style.opacity = 1;
}

function suggestions_list_expand() {
    suggestions_status.removeEventListener('transitionend', suggestions_list_expand);
    suggestions_status.style.display = 'none';
    suggestions_div.style.height = get_height(suggestions_list) + 'px';
    suggestions_div.addEventListener('transitionend', suggestions_list_fade_in, false);
}

function suggestions_reset() {
    suggestions_div.style.pointerEvents = '';
    suggestions_status.style.display = '';
    suggestions_status.style.opacity = 0;
    suggestions_list.style.opacity = '';
    suggestions_list.style.height = '';
    suggestions_list.innerHTML = '';
    suggestions_loaded = false;
}

function suggestions_collapse_all_done() {
    suggestions_div.removeEventListener('transitionend', suggestions_collapse_all_done);
    suggestions_reset();
}

function suggestions_collapse_all() {
    suggestions_div.addEventListener('transitionend', suggestions_collapse_all_done, false);
    suggestions_div.style.height = 0;
}

function suggestions_list_collapse() {
    suggestions_list.removeEventListener('transitionend', suggestions_list_collapse);
    suggestions_list.innerHTML = '';
    suggestions_loaded = false;
    suggestions_div.style.height = get_height(suggestions_status) + 'px';
}

function suggestions_list_fade_out() {
    suggestions_list.addEventListener('transitionend', suggestions_list_collapse, false);
    suggestions_list.style.opacity = 0;
}

function abort_suggestions() {
    if (suggestions_request_active) {
        suggestions_request.abort();
        suggestions_request_active = false;
    }
}

function search_suggestions(field) {

    abort_suggestions();

    // Minimal character input
    if (field.value.length > 3) {

        min_query_length = true;
        suggestions_query.textContent = '\'' + field.value + '\'';
        suggestions_div.style.display = 'block';
        suggestions_status_expand();
        if (suggestions_loaded) {
            suggestions_list_fade_out();
        } else {
            suggestions_list_collapse();
        }
        suggestions_request_active = true;
        suggestions_request = new XMLHttpRequest();
        suggestions_url = '/search-suggestions?q=' + field.value;
        suggestions_request.open('GET', suggestions_url, true);
        suggestions_request.onload = function () {
            if (this.status >= 200 && this.status < 400) {
                // Success
                suggestions_request_active = false;
                suggestions_loaded = true;
                suggestions_list.innerHTML = this.response;
                suggestions_status.style.opacity = 0;
                suggestions_status.addEventListener('transitionend', suggestions_list_expand, false);
            } else {
                // Connection made, but another error occurred
            }
        }
        suggestions_request.onerror = function () {
            // There was a connection error
        }
        suggestions_request.send();

    } else {

        min_query_length = false;
        suggestions_collapse_all();

    }

}

var search_el;
var search_expandable;

function close_header_search_done() {
    // Reset but leave any field input
    search_el.classList.remove('closing');
    search_el.querySelector('.open').setAttribute('aria-hidden', 'false');
    search_el.querySelector('.search-expandable').setAttribute('aria-hidden', 'true');
    search_el.querySelector('.search-expandable').setAttribute('aria-expanded', 'false');
    search_el.querySelector('input').setAttribute('disabled', 'disabled');
    search_el.querySelector('button').setAttribute('disabled', 'disabled');
    search_el.querySelector('.close').setAttribute('aria-hidden', 'true');
    // Remove listener otherwise the transition recurs on open, and all the elements get disabled or aria-hidden etc again
    search_expandable.removeEventListener('transitionend', close_header_search_done);
    suggestions_div.style.height = 0;
}

function close_header_search() {
    if (search_el && search_el.classList.contains('open')) {
        search_el.classList.remove('open');
        search_el.classList.add('closing');
        suggestions_reset();
        suggestions_div.style.display = '';
        search_expandable.addEventListener('transitionend', close_header_search_done, false);
    }
}

function open_header_search_done() {
    search_expandable.removeEventListener('transitionend', open_header_search_done);
}

function open_header_search() {
    var search_el = document.querySelector('header .search');
    if (search_el && !search_el.classList.contains('open')) {
        search_el.classList.add('open');
        search_el.querySelector('.open').setAttribute('aria-hidden', 'true');
        search_el.querySelector('.search-expandable').setAttribute('aria-hidden', 'false');
        search_el.querySelector('.search-expandable').setAttribute('aria-expanded', 'true');
        search_el.querySelector('input').removeAttribute('disabled');
        search_el.querySelector('button').removeAttribute('disabled');
        search_el.querySelector('.close').setAttribute('aria-hidden', 'false');
        search_expandable.addEventListener('transitionend', open_header_search_done, false);
    }
}

function set_search_elements() {
    var nav_parent;
    if (actual_width < lg) {
        nav_parent = document.querySelector('#mobile-main-menu');
    } else {
        nav_parent = document.querySelector('header');
    }
    if(!nav_parent) return;

    search_el = nav_parent.querySelector('.search');
    search_expandable = search_el.querySelector('.search-expandable');
    suggestions_div = nav_parent.querySelector('.search-suggestions');
    suggestions_status = suggestions_div.querySelector('.suggestions-status');
    suggestions_query = suggestions_status.querySelector('.query');
    suggestions_list = suggestions_div.querySelector('.suggestions-list');
}

function open_nav_submenu(menu) {
    menu.parentNode.classList.add('dropdown-open');
    menu.parentNode.querySelector('.dropdown-menu').setAttribute('aria-hidden', 'false');
    menu.parentNode.querySelector('.dropdown-menu').setAttribute('aria-expanded', 'true');
    if (actual_width < md) {
        var height = get_height(menu.parentNode.querySelector('.dropdown-menu'));
        menu.parentNode.querySelector('.dropdown-menu').style.height = height + 'px';
    }
}

function close_nav_submenu(menu) {  
    menu.parentNode.classList.remove('dropdown-open');
    menu.parentNode.querySelector('.dropdown-menu').setAttribute('aria-hidden', 'true');
    menu.parentNode.querySelector('.dropdown-menu').setAttribute('aria-expanded', 'false');
    if (actual_width < md) {
        menu.parentNode.querySelector('.dropdown-menu').style.height = '0px';
    } else {
        menu.parentNode.querySelector('.dropdown-menu').style.height = '';
    }
}

function close_any_submenu() {
    var open_submenu = document.querySelector('.site-header .dropdown-open');
    if (open_submenu) {
        close_nav_submenu(open_submenu.firstChild);
    }
}

function compile_more_nav() {

    var active_subnav = document.querySelector('.site-header .navbar-nav > .active');
    if (active_subnav) {
        var more_submenu = active_subnav.querySelector('.more-submenu > ul');
        var subnav_max_w;
        // Because overflow differs when nav is centered above 1200px
        if (actual_width >= xxl) {
            subnav_max_w = window.innerWidth - ((more_submenu.parentNode.clientWidth + 20) * 2);// Compensate for padding and double width because subnav is centered
        } else {
            subnav_max_w = window.innerWidth - (more_submenu.parentNode.clientWidth + (20 * 2));// Compensate for padding
        }
        var subnav = active_subnav.querySelector('.dropdown-menu');
        var subnav_w = 0;
        // For loops based on length aren't great here because the length changes when we move elements...
        // Start by restoring anything in the More submenu to the original submenu
        while (more_submenu.children.length > 0) {
            subnav.appendChild(more_submenu.children[0]);
        }
        // Identify and assign a class to the overflowing items
        for (var i = 0; i < subnav.children.length; i++) {
            var child = subnav.children[i];
            child.classList.remove('js-more-link');
            if (!child.classList.contains('more-submenu')) {
                subnav_w += child.clientWidth;
                // Because overflow differs when nav is centered above 1200px
                if (actual_width >= xxl) {
                    if (subnav_w / 2 > subnav_max_w / 2) {
                        child.classList.add('js-more-link');
                    }
                } else {
                    if (subnav_w > subnav_max_w) {
                        child.classList.add('js-more-link');
                    }
                }
            }
        }
        // Make the More submenu last child
        subnav.appendChild(more_submenu.parentNode);
        // Move the overflowing items to the More submenu
        var items = subnav.querySelectorAll('.js-more-link');
        if (items.length > 0) {
            more_submenu.parentNode.classList.remove('disabled');
            Array.prototype.forEach.call(items, function(el, i) {
                var child = items[i];
                more_submenu.append(child);
            });
        } else {
            more_submenu.parentNode.classList.add('disabled');
        }
    }

}

function set_header_height() {

    // Without this an active submenu can overlap the page title because that element is absolute positioned  

    var header = document.querySelector('header.site-header');
    if (header && actual_width >= md) {
        header.style.paddingBottom = '';
        var active_submenu = header.querySelector('.nav-item.active > .dropdown-menu');
        if (active_submenu) {
            var submenu_h = active_submenu.clientHeight;
            var header = document.querySelector('header.site-header');
            header.style.paddingBottom = submenu_h + 'px';// Use padding not margin to preserve dropshadow effect on detached nav
        }
    }

}

function refresh_mobile_nav() {
    document.body.style.height = '';
    var mobile_nav_h = mobile_nav.querySelector('#mobile-menu-contents').clientHeight;
    if (document.body.clientHeight < mobile_nav_h) {
        document.body.style.height = mobile_nav_h + 'px';
    }
}

var swipers;
function refresh_swipers() {
    if (swipers) {
        Array.prototype.forEach.call(swipers, function(el, i) {
            var swiper = swipers[i];
            var images = swiper.querySelectorAll('.img img');
            Array.prototype.forEach.call(images, function(el, j) {

                var image = images[j];

                image.style.width = '';
                image.style.height = '';
                image.style.top = '';

                var swiper_h = swiper.clientHeight;
                var swiper_w = swiper.clientWidth;
                var image_h = image.clientHeight;
                var image_w = image.clientWidth;

                if (image_w < swiper_w) {
                    image.style.width = '100%';
                    image.style.height = 'auto';
                    var image_y = Math.round((image_h - swiper_h) / 100);
                    image.style.top = (image_y * -1) + 'px';
                }

            });
        });
    }
}

function on_scroll() {

    // Handle differing browser support for scrollTop
    if (document.documentElement.scrollTop !== 0) {
        page_pos = document.documentElement.scrollTop;
    } else {
        page_pos = document.body.scrollTop;
    }

    var header = document.querySelector('header');
    if(header){
        if (page_pos > 0) {
            header.classList.add('sticking');
        } else {
            header.classList.remove('sticking');
        }
    }

}

// Horizontal alignment functions
// These line up child nodes in every container in a row, and is responsive

// The relevant tags whose heights will be matched
var child_types = ['IMG', 'DIV', 'A', 'P', 'H5', 'H4', 'H3', 'H2', 'H1', 'UL', 'OL', 'BLOCKQUOTE'];

function align_children(row, child) {
    var height;
    var tallest = 0;
    // Compare children heights
    Array.prototype.forEach.call(row, function(el, i) {
        var this_row = row[i];
        if (child === undefined) {
            // Simply match children eg cols
            height = this_row.clientHeight;
        } else {
            // Match elements within children
            height = this_row.children.item(child).clientHeight;
        }
        if (height > tallest) {
            tallest = height;
        }
    });
    // Apply largest height to all
    Array.prototype.forEach.call(row, function(el, i) {
        var this_row = row[i];
        if (tallest > 0) {
            if (child === undefined) {
                // Simply match children eg cols
                this_row.style.height = tallest + 'px';
            } else {
                // Match elements within children
                this_row.children.item(child).style.height = tallest + 'px';
            }
        }
    });
}

function reset_alignments(targets) {
    Array.prototype.forEach.call(targets, function(el, i) {
        var target = targets[i];
        target.style.height = '';
        var target_children = target.children;
        Array.prototype.forEach.call(target_children, function(el, j) {
            target_children[j].style.height = '';
        });
    });
}

function refresh_alignments() {

    /* Usage

    Match the height of immediate children containers ONLY across three columns desktop, two on tablet and ignore on phone:
    <div class="row js-align-children" data-align-cols-st="2" data-align-cols-tb="2" data-align-cols-ph="1">
    NB you should probably just use flex to achieve this btw, but it might be useful
    NB It's used on Courses & events search filters in case someone stacks up a field with multiple filters

    Match the height of the immediate children of descendant containers so that headings, blurbs, CTAs etc line-up
    <div class="row js-align-descendants" data-align-cols-st="2" data-align-cols-tb="2" data-align-cols-ph="1">
    Then add js-align-contents class to the parent node of the elements you want to align, eg: 
    <div class="promo col-sm-4 js-align-contents">
    NB It's used in Courses & events landing page promos and search result summaries

    */

    var parents = document.querySelectorAll('.js-align-descendants, .js-align-children');
    Array.prototype.forEach.call(parents, function(el, i) {

        var parent = parents[i];

        // Use the classes to find out if immediate children or deeper children are being aligned
        var type;
        var targets;
        if (!parent.classList.contains('js-align-children')) {
            type = 'children';
            targets = parent.querySelectorAll('.js-align-contents');
        } else {
            type = 'self';
            targets = parent.children;
        }

        // Get number of cols in row
        // These data attributes need to be present on the parent tag
        var cols;
        if (actual_width < sm) {
            cols = parseInt(parent.getAttribute('data-align-cols-ph'));
        } else if (actual_width >= sm && actual_width < lg) {
            cols = parseInt(parent.getAttribute('data-align-cols-tb'));
        } else {
            cols = parseInt(parent.getAttribute('data-align-cols-st'));
        }

        // Clear previously applied heights otherwise they will compound
        reset_alignments(targets);
        
        // Only apply heights if more than one target on a row
        if (targets.length > 0 && cols > 1) {

            if (type == 'children') {

                // Iterate through children of first target
                var target_children = targets.item(0).children;
                Array.prototype.forEach.call(target_children, function(el, j) {
                    // Check child exists
                    if (target_children[j]) {
                        // Iterate through permitted child types
                        for (var k = 0; k < child_types.length; k++) {
                            // If a child type matches target child
                            if (child_types[k] == target_children[j].tagName) {
                                // Group into rows of each child type
                                for (var l = 0; l < targets.length; l += cols) {
                                    var targets_array = Array.from(targets);
                                    var target_cols = targets_array.slice(l, l + cols);
                                    align_children(target_cols, j);
                                }
                            }
                        }
                    }
                });

            } else if (type == 'self') {

                // No need to check child_types as per the descendants method because this children method is most
                // likely to be used for more simple applications like equalising the height of a row of divs

                var target_children = [];
                
                Array.prototype.forEach.call(targets, function(el, j) {
                    if (targets[j].tagName == 'DIV') {
                        target_children.push(targets[j]);
                    }
                });

                align_children(target_children);

            }
            
        }
    });

}

// PDP (members only)

var listing_pos;

function on_pdp_scroll(pdp_listing) {

    listing_pos = pdp_listing.scrollTop;

    if (listing_pos > 0) {
        pdp_listing.classList.add('scrolled');
    } else {
        pdp_listing.classList.remove('scrolled');
    }

}

var pdp_scroll = false;

function refresh_member_dashboard() {

    var cols = document.querySelector('.pdp-checkup-cols');
    if (cols) {

        // Set up
        cols.style.height = '';
        var pdp_listing = document.querySelector('.pdp-listing');
        pdp_listing.style.height = '';
        var col_height = cols.clientHeight;
        var window_height = window.innerHeight;
        var pdp_listing_height = 0;

        // If not mobile
        if (actual_width > lg) {// Not >=

            // Adjust height of both main cols to fit screen
            var title_height = document.querySelector('.page-header').clientHeight;
            col_height = window_height - nav_height - title_height;
            cols.style.height = col_height + 'px';

            // Limit height of events attended listing
            var pdp_header_height = document.querySelector('.pdp-main').clientHeight;
            var pdp_footer_height = document.querySelector('.pdp-code').clientHeight;
            pdp_listing_height = col_height - pdp_header_height - pdp_footer_height;

        }

        // Limit listing height
        var min_listing_height = 150;
        if (pdp_listing_height < min_listing_height) {
            pdp_listing_height = min_listing_height;
        }
        pdp_listing.style.height = pdp_listing_height + 'px';

        // Reapply cols height once listing height established
        cols.style.height = '';

        // Set the dash offset which determines the completeness of the progress ring
        var circle = document.querySelector('.pdp-dial .bar');

        // Update the dash offset (which needs to change if dial resizes) and the big percentage number
        function setProgress(percent) {
            var circle_style = window.getComputedStyle(circle);
            var radius = parseFloat(circle_style.r);
            var circumference = radius * 2 * Math.PI;
            circle.style.strokeDasharray = `${circumference} ${circumference}`;
            circle.style.strokeDashoffset = `${circumference}`;
            var offset = circumference - percent / 100 * circumference;
            circle.style.strokeDashoffset = offset;
            readout.textContent = percent;
        }
        var readout = document.querySelector('.pdp-datavis .number');
        var dial = document.querySelector('.pdp-dial');
        var progress = dial.getAttribute('data-progress');
        setProgress(progress);

        // Get the scrollbar width to compensate for the listing's scrollbar on affected browsers
        var scrollbar_width;
        var scrolled_width = pdp_listing.clientWidth;
        pdp_listing.style.overflow = 'hidden';
        var unscrolled_width = pdp_listing.clientWidth;
        pdp_listing.style.overflow = '';
        scrollbar_width = unscrolled_width - scrolled_width;

        // Adjust the listing's elements to compensate for the listing's scrollbar on affected browsers
        var pdp_listing_els = document.querySelectorAll('.pdp-listing > div');
        var bootstrap_col_width = 12 / scrolled_width;
        Array.prototype.forEach.call(pdp_listing_els, function(el, i) {
            var pdp_listing_el = pdp_listing_els[i];
            pdp_listing_el.style.width = '';
            pdp_listing_el.style.marginLeft = '';
            var pdp_listing_el_style = window.getComputedStyle(pdp_listing_el);
            var pdp_listing_el_width = Math.round(bootstrap_col_width * parseFloat(pdp_listing_el_style.width));
            var pdp_listing_el_offset = Math.round(bootstrap_col_width * parseFloat(pdp_listing_el_style.marginLeft));
            pdp_listing_el.style.width = 'calc(((100% + ' + scrollbar_width + 'px) / 12) * ' + pdp_listing_el_width + ')';
            pdp_listing_el.style.marginLeft = 'calc(((100% + ' + scrollbar_width + 'px) / 12) * ' + pdp_listing_el_offset + ')';
        });

        // Check if scrolling required
        pdp_listing.style.height = '';
        var native_listing_height = pdp_listing.clientHeight;
        pdp_listing.style.height = pdp_listing_height + 'px';
        if (native_listing_height > pdp_listing_height) {
            pdp_listing.classList.add('scrolling-applied');
        } else {
            pdp_listing.classList.remove('scrolling-applied');
        }

        // Create this event listener once only
        if (pdp_scroll == false) {
            on_pdp_scroll(pdp_listing);
            pdp_listing.addEventListener('scroll', function(event) {
                on_pdp_scroll(pdp_listing);
            });
            pdp_scroll = true;
        }

    }
    
}

function on_resize() {

    // Get the actual browser width

    var reported_width;
    var disabled_width;
    var scrollbar_width;

    reported_width = window.innerWidth;
    document.body.style.overflow = 'hidden';
    disabled_width = window.innerWidth;
    document.body.style.overflow = '';

    if (window.navigator.userAgent.match(/Safari/i) && !window.navigator.userAgent.match(/Chrome/i)) {
        scrollbar_width = 0;
    } else {
        scrollbar_width = disabled_width - reported_width;
    }

    prev_width = actual_width;
    actual_width = reported_width + scrollbar_width;

    nav_height = document.querySelector('.site-header').clientHeight;

    // If different to set media, media query has changed

    if (actual_width < xs ) {
        check_media = 'xs';
    } else if (actual_width >= xs && actual_width < sm) {
        check_media = 'sm';
    } else if (actual_width >= sm && actual_width < md) {
        check_media = 'md';
    } else if (actual_width >= md && actual_width < lg) {
        check_media = 'lg';
    } else if (actual_width >= lg && actual_width < xl) {
        check_media = 'xl';
    } else if (actual_width >= xl) {
        check_media = 'xxl';
    }

    if (check_media !== curr_media) {

        prev_media = curr_media;
        curr_media = check_media;

        // Functions that need to be rerun on media change
        set_search_elements();

    }

    // Functions that need to be rerun on ANY resizing
    
    if (actual_width >= sm) {
        // ...
    }

    if (prev_width != actual_width) {
        // Prevents the search, if expanded, from collapsing on window load 
        close_header_search();
    }
    close_any_submenu();
    compile_more_nav();
    set_header_height();
    refresh_swipers();
    refresh_member_dashboard();// Always before refresh alignments
    refresh_alignments();
    refresh_suggestions();

}

document.addEventListener('DOMContentLoaded', function(event) {

    // Vars that need to be set before on_resize is fired
    set_search_elements();
    
    on_resize();
    window.addEventListener('resize', function(event) {
        on_resize();
    });

    on_scroll();
    window.addEventListener('scroll', function(event) {
        on_scroll();
    });

    // Trigger page refresh on image load
    var images = document.querySelectorAll('img');
    Array.prototype.forEach.call(images, function(el, i) {
        if (!images[i].complete || images[i].naturalHeight == 0) {
            // images[i].classList.add('image-loading');
            images[i].onload = function() {
                on_resize();
                // images[i].classList.remove('image-loading');
            }
        }
    });

    // Remove white space from between nav <li>s
    var list_els = document.querySelectorAll('nav ul');
    Array.prototype.forEach.call(list_els, function(el, i) {
        var html = list_els[i].innerHTML;
        list_els[i].innerHTML = html.replace(/(<\/(?:li|div|a)>)\s*/g, '$1');
    });

    // Refresh after any sprig query completes
    htmx.on("htmx:afterSettle", function (event) {
        on_resize();
    });

    // Mobile nav height fix when position and height exceeds page height
    mobile_nav = document.querySelector('#mobile-main-menu');
    mobile_nav_content = document.querySelector('#mobile-menu-contents .search');
    mobile_nav_content.style.paddingTop = nav_height + page_pos + 'px';
    refresh_mobile_nav();

    // Mobile nav content positioning fix when scrolled down on long pages
    var mobile_nav_button = document.querySelector('header .navbar-toggler');
    var site_header = document.querySelector('.site-header');
    if (mobile_nav_button) {
        mobile_nav_button.addEventListener('click', event => {
            event.preventDefault();
            if (!mobile_nav_content.classList.contains('open')) {
                mobile_nav_content.style.paddingTop = nav_height + page_pos + 'px';
                refresh_mobile_nav();
                site_header.classList.remove('sticking');
            } else {
                document.body.style.height = '';
            }
        });
    }

    // Open header search button
    var open_search_buttons = document.querySelectorAll('header .search a.open, header .search label');
    Array.prototype.forEach.call(open_search_buttons, function(el, i) {
        open_search_buttons[i].addEventListener('click', event => {
            event.preventDefault();
            open_header_search();
        });
    });

    // Close header search button
    var close_search_button = document.querySelector('header .search a.close');
    if (close_search_button) {
        close_search_button.addEventListener('click', event => {
            event.preventDefault();
            close_header_search();
        });
    }

    // Remove disabled attributes and set aria attributes on mobile search
    var mobile_search = document.querySelector('#mobile-main-menu .search');
    if (mobile_search) {
        mobile_search.querySelector('.open').setAttribute('aria-hidden', 'true');
        mobile_search.querySelector('.search-expandable').setAttribute('aria-hidden', 'false');
        mobile_search.querySelector('.search-expandable').setAttribute('aria-expanded', 'true');
        mobile_search.querySelector('input').removeAttribute('disabled');
        mobile_search.querySelector('button').removeAttribute('disabled');
        mobile_search.querySelector('.close').setAttribute('aria-hidden', 'true');
    }
    
    // Close header search if keyboard focus goes to next element
    // NB Login is not there if logged in so the first main nav link is also included
    var next_tabbables = document.querySelectorAll('header .login a, header .navbar-nav > li:first-of-type > a:first-of-type');
    Array.prototype.forEach.call(next_tabbables, function(el, i) {
        next_tabbables[i].addEventListener('focus', event => {
            close_header_search();
        });
    });

    // Search suggestions
    hide_suggestions();
    var search_fields = document.querySelectorAll('header .search input, #mobile-main-menu .search input');
    Array.prototype.forEach.call(search_fields, function(el, i) {
        var field = search_fields[i];
        field.addEventListener('input', event => {
            search_suggestions(field);
        });
    });

    // Activate nav sub-menus for accessibility
    // Improved upon this https://www.w3.org/WAI/tutorials/menus/flyout/#flyoutnavmousefixed
    var menuItems = document.querySelectorAll('.navbar-nav li');// Include the first fo usable object after header
    Array.prototype.forEach.call(menuItems, function(el, i) {

        // Manage menu if keyboard triggers the dropdown bullet element
        if (el.classList.contains('dropdown')) {
            // Toggle menu with keyboard
            el.querySelector('button.dropdown-toggle').addEventListener('click', function(event) {
                if (actual_width > lg) {
                    if (this.parentNode.classList.contains('dropdown-open')) {
                        close_nav_submenu(this);
                    } else {
                        open_nav_submenu(this);
                    }
                    // event.preventDefault();
                } else {
                    refresh_mobile_nav();
                }
            });
            // Close menu on mouseout if opened by dropdown bullet click or (less likely) by keyboard first
            el.addEventListener('mouseout', function(event) {
                if (this.classList.contains('dropdown-open') && actual_width >= md) {
                    close_nav_submenu(this.firstChild);
                }
            });
        }

        // Close menu if keyboard focus goes to next nav element
        let aTag = el.querySelector('a')
        if (aTag){
            el.querySelector('a').addEventListener('focus', function(event) {
                var open_submenu = el.parentNode.querySelector('.dropdown-open');
                if (open_submenu) {
                    close_nav_submenu(open_submenu.firstChild);
                }
            }); 
        }
    });

    // Close menu if keyboard focus leaves nav
    let headerA = document.querySelector('.site-header ~ * a');
    if(headerA){
        headerA.addEventListener('focus', function(event) {
            // var open_submenu = document.querySelector('.site-header .dropdown-open');
            // if (open_submenu) {
            //     close_nav_submenu(open_submenu.firstChild);
            // }
            close_any_submenu();
        });
    }

    swipers = document.querySelectorAll('.swiper-container');

});

window.addEventListener('load', function() {
    on_resize();
});